import React, {ChangeEvent, ReactElement, useRef} from 'react';
import {Switch} from '@material-ui/core';
import {Nil} from '../model/SharedTypes';
import styles from './NxSwitch.scss';
import {logMissingOnChange} from '../inputError';

export interface NxSwitchProps {
  checked?: boolean | null;
  name?: string;
  onBlur?: (e: ChangeEvent) => void;
  onChange?: (e: ChangeEvent) => void;
}

const calculateValue = (newChecked: boolean | Nil, previousChecked: boolean | Nil): boolean => {
  if (newChecked === null) {
    return previousChecked ?? false;
  }

  return !!newChecked;
}

const NxSwitch = ({ checked, name, onBlur, onChange: parentOnChange }: NxSwitchProps): ReactElement => {
  const switchClasses = {
    root: styles.switch,
    switchBase: styles.switchBase,
    thumb: styles.thumb,
    track: styles.track,
    input: styles.input
  };

  const lastValue = useRef(checked ?? false);
  const finalValue = calculateValue(checked, lastValue.current);
  lastValue.current = finalValue;

  const onChange: (event: ChangeEvent<HTMLInputElement>) => void = (event: ChangeEvent<HTMLInputElement>): void => {
    lastValue.current = event.target.checked;

    if (!parentOnChange) {
      logMissingOnChange('Switch', name);
      return;
    }

    parentOnChange(event);
  };

  return <Switch color='primary'
                 classes={switchClasses}
                 name={name}
                 checked={finalValue}
                 onBlur={onBlur}
                 onChange={onChange} />;
}

export default NxSwitch;
